import { media } from "../config";

export const isMobile = {
  data: function() {
    return {
      isMobile: false,
      isTablet: false
    };
  },
  methods: {
    testMediaQuery: function() {
      const mql = window.matchMedia(`(max-width: ${media.mobile}px)`);
      this.isMobile = mql ? mql.matches : false;

      const mqlTablet = window.matchMedia(`(max-width: ${media.tablet}px)`);
      this.isTablet = mqlTablet ? mqlTablet.matches : false;
    }
  },
  created: function() {
    this.testMediaQuery();
    window.addEventListener("resize", this.testMediaQuery);
  },
  destroyed: function() {
    window.removeEventListener("resize", this.testMediaQuery);
  }
};
